import { keepPreviousData, useQuery } from '@tanstack/react-query';
import API, { sectionsApiUrl as SectionsQK, articlesApiUrl as MaterialQK } from './api';
import { ResponseType } from 'src/constants/data';
import { KBFilter, ModuleSearchRequest } from 'src/types';

export const useGetSections = (params: Partial<KBFilter>) => {
  return useQuery({
    queryKey: [SectionsQK, ResponseType.List, params],
    queryFn: () => API.search(params),
    placeholderData: keepPreviousData
  });
};

export const useGetSection = (slug: string) => {
  return useQuery({
    queryKey: [SectionsQK + `/${slug}`, ResponseType.List, slug],
    queryFn: () => API.getSection(slug),
    placeholderData: keepPreviousData
  });
};

export const useGetModule = (params: ModuleSearchRequest) => {
  return useQuery({
    queryKey: [SectionsQK + `/module`, ResponseType.List, params],
    queryFn: () => API.getModule(params),
    placeholderData: keepPreviousData
  });
};

export const useGetMaterial = (params: string) => {
  return useQuery({
    queryKey: [MaterialQK, ResponseType.Single, params],
    queryFn: () => API.getMaterial(params),
    enabled: !!params && params.length > 0
  });
};
